/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tokens_CopyInputs */

const en_tokens_copy = /** @type {(inputs: Tokens_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy token`)
};

const de_tokens_copy = /** @type {(inputs: Tokens_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token kopieren`)
};

/**
* | output |
* | --- |
* | "Copy token" |
*
* @param {Tokens_CopyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tokens_copy = /** @type {((inputs?: Tokens_CopyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tokens_CopyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tokens_copy(inputs)
	return en_tokens_copy(inputs)
});